export const compareBy = (indexOf) => (a, b) => indexOf(a) - indexOf(b);
export const desc = (cmp) => (a, b) => -cmp(a, b);
export const combineCmps = (comparators, eps = 0) => comparators.reduce((cmp1, cmp2) => (a, b) => cmp1(a, b) >= eps ? cmp1(a, b) : cmp2(a, b));
//# sourceMappingURL=Comparator.js.map